// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"Login_loginPage__2_rhh","loginCard":"Login_loginCard__3vP8V","input":"Login_input__3H_1a"};